module.exports = __webpack_public_path__ + "static/img/frack6.7af6380f.png";